import CampaignInsightCard from "@/features/campaigns/components/UserCampaigns/components/CampaignInsightCard";
import { getTextColorBasedOnValue } from "@/shared/utils/helperFunctions";
import { Clipboard, Mail, Reply } from "lucide-react";
import React, { useMemo } from "react";
import { useGetDsahboardCampaignPerformance } from "../hooks/useGetDashboardApi";
import {
  buildOpenRateAnalytics,
  buildReplyRateAnalytics,
  formatDashboardPercent,
} from "@/shared/utils/dashboardConfig";

const CampaignPerformance = ({ days = 30 }) => {
  const { data: dashboardCampaignPerformanceData } =
    useGetDsahboardCampaignPerformance(days);

  const insightsData = useMemo(() => {
    const openRate = dashboardCampaignPerformanceData?.open_rate;
    const replyRate = dashboardCampaignPerformanceData?.reply_rate;
    const openAgg = openRate?.aggregate ?? 0;
    const replyAgg = replyRate?.aggregate ?? 0;

    return [
      {
        title: "Total Active Campaigns",
        value: `${dashboardCampaignPerformanceData?.total_active_campaigns || 0}`,
        icon: (
          <Clipboard
            className={getTextColorBasedOnValue(90)}
            size={22}
            strokeWidth={1.5}
          />
        ),
        description: "AI generates 3.8× more outcomes per rep.",
        textColor: getTextColorBasedOnValue(90),
        analytics: undefined,
        total: `${dashboardCampaignPerformanceData?.total_active_campaigns || 0}`,
      },
      {
        title: "Opened",
        value: formatDashboardPercent(openAgg),
        icon: (
          <Mail
            className={getTextColorBasedOnValue(openAgg)}
            size={22}
            strokeWidth={1.5}
          />
        ),
        description: "How often your messages get opened by prospects.",
        textColor: getTextColorBasedOnValue(openAgg),
        analytics: buildOpenRateAnalytics(openRate),
        total: 100,
      },
      {
        title: "Reply Rate",
        value: formatDashboardPercent(replyAgg),
        icon: (
          <Reply
            className={getTextColorBasedOnValue(replyAgg)}
            size={22}
            strokeWidth={1.5}
          />
        ),
        description: "How many prospects replied to your outreach.",
        textColor: getTextColorBasedOnValue(replyAgg),
        analytics: buildReplyRateAnalytics(replyRate),
        total: 100,
      },
      // {
      //   title: "Meetings Booked",
      //   value: "50",
      //   icon: (
      //     <Calendar className="text-success-500" size={22} strokeWidth={1.5} />
      //   ),
      //   description: "How many conversations converted into real meetings.",
      //   textColor: "text-success-500",
      // },
    ];
  }, [dashboardCampaignPerformanceData]);

  return (
    <div className="flex flex-col gap-3">
      {insightsData?.map((item, index) => (
        <CampaignInsightCard
          borderCard={true}
          key={item.title}
          index={index}
          title={item.title}
          value={item.value}
          total={item.total}
          icon={item.icon}
          description={item.description}
          textColor={item.textColor}
          analytics={item.analytics}
          isActive={false}
          onToggle={() => {}}
          handleView={() => {}}
          interactionMode="hover"
          isDashboard={true}
        />
      ))}
    </div>
  );
};

export default CampaignPerformance;
